import styled from '@xstyled/styled-components'
import { TextArea } from '../textarea'

export const StyledTextArea = styled(TextArea).withConfig({
  shouldForwardProp: prop => prop !== 'borderType'
})(
  {
    padding: '12px',
    background: 'transparent'
  },
  props => ({
    borderColor:
      props.borderType === 'always' ? props.theme.colors.grey.l2 : 'transparent'
  }),
  props =>
    ['always', 'hover'].includes(props.borderType) && {
      '&:hover': {
        borderColor:
          props.borderType === 'hover'
            ? props.theme.colors.grey.l2
            : props.theme.colors.grey.d2,
        '&:focus': {
          borderColor: props.theme.colors.primary.base
        }
      }
    }
)
